/*
 * @Author: 侯鹏许 
 * @Date: 2019-06-09 16:18:10 
 * @Last Modified by: 侯鹏许
 * @Last Modified time: 2019-06-10 11:26:56
 */
<template>
  <div class="container">
    <div class="banner">
      <swiper class="banner_swiper" ref="bannerSwiper" :options="banner.swiperOption">
        <swiperSlide v-for="(item,index) in banner.items" :key="index">
          <img class="banner_swiper_img" :src="item.imgUrl" @click="tapBanner(item)">
        </swiperSlide>
        <div class="swiper-pagination" slot="pagination"></div>
        <!-- <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>-->
        <!-- <div class="swiper-scrollbar" slot="scrollbar"></div> -->
      </swiper>
    </div>

    <div class="list">
      <div class="item" v-for="(item,index) in dynamicList">
        <div class="item_tr">
          <div class="item_title">{{item.title}}</div>
          <!-- <div class="item_read">{{item.readCount}}人阅读</div> -->
        </div>
        <div class="item_img">
          <img :src="item.img">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    swiper,
    swiperSlide
  },
  props: {},
  data() {
    return {
      // Banner
      banner: {
        swiperOption: {
          autoplay: {
            delay: 2500
          },
          pagination: {
            el: ".swiper-pagination"
          }
        },
        items: [
          {
            imgUrl:
              "https://yqweb.oss-cn-shanghai.aliyuncs.com/yq-rs-wx/yybdgyqmjjr/banner1.jpg",
            linkUrl: ""
          },
          {
            imgUrl:
              "https://yqweb.oss-cn-shanghai.aliyuncs.com/yq-rs-wx/yybdgyqmjjr/banner2.jpg",
            linkUrl: ""
          },
          {
            imgUrl:
              "https://yqweb.oss-cn-shanghai.aliyuncs.com/yq-rs-wx/yybdgyqmjjr/banner3.jpg",
            linkUrl: ""
          },
          {
            imgUrl:
              "https://yqweb.oss-cn-shanghai.aliyuncs.com/yq-rs-wx/yybdgyqmjjr/banner4.jpg",
            linkUrl: ""
          }
        ]
      },
      dynamicList: [
        {
          id: 0,
          title: "洞庭国际·半岛公园5100元/平方米",
          content:
            "洞庭国际·半岛公园5100元/平方米起。绿化率35%。容积率1.8。物业费：1.6元/㎡·月。2019年03月28日G1获得预售许可证：岳建预（2019）第052号。洞庭国际·半岛公园楼盘地址：黄河大道1号。项目为低层,小高层,高层板塔结合。2019年3月29日G1栋已开盘。岳阳雅礼实验学校、湖南师大附中、湘一南湖学校、枫树山小学、湖滨小学、湘北女校,岳阳民康康复医院,农业银行、农商银行等,中通、顺丰、韵达等,五星级铂尔曼酒店、国际高尔夫球场、高尔夫主题生态体育公园。敬请关注。",
          img:
            "https://yqweb.oss-cn-shanghai.aliyuncs.com/yq-rs-wx/yybdgyqmjjr/banner1.jpg",
          readCount: "105",
          createtime: "2019-05-16 01:06:20",
          linkUrl: "https://w.url.cn/s/ARgHOnC"
        },
        {
          id: 1,
          title: "洞庭国际·半岛公园五一奇趣玩乐海翻天",
          content:
            "洞庭国际·半岛公园五一游乐嘉年华，奇趣玩乐嗨翻天。洞庭国际·半岛公园为家长小朋友们准备了真人娃娃机、疯狂抓钱机、VR趣味体验、欢乐套圈圈、儿童趣味钓鱼、T恤DIY等活动，还有整点抽奖。参与条件：关注洞庭国际·半岛公园微信公众号领取活动参与券，完成所有活动的朋友还可领取一份精美礼物。",
          img:
            "https://yqweb.oss-cn-shanghai.aliyuncs.com/yq-rs-wx/yybdgyqmjjr/banner2.jpg",
          readCount: "84",
          createtime: "2019-04-30 15:25:25",
          linkUrl: "https://w.url.cn/s/AtlN4ac"
        },
        {
          id: 2,
          title: "洞庭国际·半岛公园 4月27日H6栋全城荣耀发售",
          content:
            "洞庭国际·半岛公园，5字头建面约100-130㎡湖景美宅，4月27日H6栋全城荣耀发售。H6栋95折优惠，活动时间2019年4月27日-5月5日。",
          img:
            "https://yqweb.oss-cn-shanghai.aliyuncs.com/yq-rs-wx/yybdgyqmjjr/banner3.jpg",
          readCount: "65",
          createtime: "2019-04-25 14:02:46",
          linkUrl: "https://w.url.cn/s/AjVrQsJ"
        }
      ]
    };
  },
  watch: {},
  computed: {
    bannerSwiper() {
      return this.$refs.bannerSwiper.swiper;
    }
  },
  methods: {
    tapBanner(item) {
      if (item.linkUrl) {
        util.openUrl(item.linkUrl);
      }
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="css" >
.container {
}
.banner {
  width: 100%;
  margin: 0 auto;
  padding-top: 10px;
}
/* Banner */
.banner_swiper {
  width: 100%;
}
.banner_swiper img {
  width: 98%;
  margin-left: 1%;
  /* 对应的iphone 678 宽度375 */
  height: 150px;
  border-radius: 0.2rem;
}

.list {
  /* padding-top: 0.125rem; */
}
.list .item {
  display: flex;
  padding: 0.2rem;
  border-bottom: 2px solid #fbfbfb;
}

.list .item_tr {
  width: 84%;
  height: 1rem;
  line-height: 1rem;
}
.list .item_title {
  width: 100%;
  font-size: 14px;
  height: 1rem;
  line-height: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.list .item_read {
  font-size: 14px;
}
.list .item_img {
  flex: 1;
  text-align: right;
}

.list .item_img img {
  width: 1rem;
  height: 1rem;
  border-radius: 5px;
}
</style>